import { useCallback } from 'react';

import { MainText } from '@/components/Typography/NamedTypo';
import service from '@/services/index';
import { ACCOUNT_COLUMNS, CONTACT_COLUMNS } from '@/types/filterKeyConst';
import { buildObjQuery, lowerCaseMatch } from '@/utils/util';

const useFetchAccountAlias = () => {
  const fetcher = useCallback(async (searchValue?: string) => {
    const query = buildObjQuery({
      [ACCOUNT_COLUMNS.NAME_SEARCH]: searchValue || null,
      sortby: 'name',
      order: 'asc',
    });
    const result = await service.account.fetchCompanyList(query);
    return result.map((account) => {
      return {
        alias: account.alias,
        searchValue: account.name,
        childNodes: [],
        node: <MainText>{account.name}</MainText>,
      };
    });
  }, []);

  return fetcher;
};

const useFetchContactAlias = () => {
  const fetcher = useCallback(async (searchValue?: string) => {
    const query = buildObjQuery({
      [CONTACT_COLUMNS.NAME_SEARCH]: searchValue || null,
      sortby: 'name',
      order: 'asc',
    });
    const result = await service.contact.fetchCustomerList(query);
    return result.map((contact) => {
      return {
        alias: contact.alias,
        searchValue: contact.name,
        childNodes: [],
        node: <MainText>{contact.name}</MainText>,
      };
    });
  }, []);

  return fetcher;
};

const useFetchAgentAlias = () => {
  const fetcher = useCallback(async (searchValue?: string) => {
    const result = await service.agent.fetchAgentList();
    return result
      .filter(
        (agent) =>
          lowerCaseMatch(agent.name, searchValue) ||
          lowerCaseMatch(agent.email, searchValue),
      )
      .map((contact) => {
        return {
          alias: contact.alias,
          searchValue: contact.name,
          childNodes: [],
          node: <MainText>{contact.name}</MainText>,
        };
      });
  }, []);

  return fetcher;
};

const customerPropertyFetcher = {
  useFetchAccountAlias,
  useFetchContactAlias,
  useFetchAgentAlias,
};

export default customerPropertyFetcher;
